require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./learning-great-start-early-learning.json") })
        }
      }, "path---learning-great-start-early-learning");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---learning-great-start-early-learning!./.cache/json/learning-great-start-early-learning.json
// module id = 1240
// module chunks = 231608221292675